import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled from "styled-components";
const IconWrapper = styled.span `
  padding: 0;
  margin: 0;
  height: ${props => props.size}px !important;
  width: ${props => props.size}px !important;
  display:flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.color || "inherit"};
`;
const Icon = styled.span `
  display: inline-block;
  font-size: ${props => props.size - 5}px;
`;
export const PlainIcon = (props) => {
    return (React.createElement(IconWrapper, { size: props.size, color: props.color },
        React.createElement(Icon, { size: props.size },
            React.createElement(FontAwesomeIcon, { icon: props.icon }))));
};
